const initOccasionFinder = () => {
  // Temporarily disabled for testing:
  if (localStorage.getItem('occasionQuizShown') === 'true') {
    return;
  }

  const overlay = document.getElementById('occasion-finder-overlay');
  const modal1 = document.getElementById('occasion-modal-1');
  const modal2 = document.getElementById('occasion-modal-2');
  const closeBtns = document.querySelectorAll('.occasion-close-btn');
  const occasionCards = document.querySelectorAll('.occasion-card');
  const ctaBtn = document.getElementById('occasion-cta-btn');
  const productsGrid = document.getElementById('occasion-products-grid');
  const occasionTitle = document.getElementById('occasion-modal-2-title');

  if (!overlay || !modal1 || !modal2) return;

  modal1.setAttribute('aria-modal', 'true');
  modal1.setAttribute('role', 'dialog');
  modal2.setAttribute('aria-modal', 'true');
  modal2.setAttribute('role', 'dialog');

  let selectedOccasion = null;

  // Set up IntersectionObserver
  const setupObserver = () => {
    // Look for the recently viewed section from the third party app, or fallback to the footer
    const targetElement = document.querySelector('[id*="recently-viewed"], [id*="17815038230ad42774"]') || document.querySelector('footer');
    
    if (targetElement) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // Trigger when the element is at least 50% visible, or if fallback, just when intersecting
          if (entry.isIntersecting) {
            showQuizModal();
            observer.disconnect();
          }
        });
      }, {
        threshold: 0.1 // Trigger when 10% visible
      });
      observer.observe(targetElement);
    } else {
      // Fallback: trigger after scrolling 50% of the page
      const handleScroll = () => {
        const scrolled = window.scrollY;
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (scrolled > maxScroll * 0.5) {
          showQuizModal();
          window.removeEventListener('scroll', handleScroll);
        }
      };
      window.addEventListener('scroll', handleScroll);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModals();
      return;
    }
    if (e.key === 'Tab') {
      const activeModal = modal1.classList.contains('is-active') ? modal1 : (modal2.classList.contains('is-active') ? modal2 : null);
      if (!activeModal) return;
      
      const focusableElements = activeModal.querySelectorAll('a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusableElements.length === 0) return;
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      
      if (e.shiftKey) { // Shift + Tab
        if (document.activeElement === firstFocusableElement || !activeModal.contains(document.activeElement)) {
          lastFocusableElement.focus();
          e.preventDefault();
        }
      } else { // Tab
        if (document.activeElement === lastFocusableElement || !activeModal.contains(document.activeElement)) {
          firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  };

  const showQuizModal = () => {
    overlay.classList.add('is-active');
    modal1.classList.add('is-active');
    document.body.classList.add('occasion-modal-open');
    localStorage.setItem('occasionQuizShown', 'true');
    document.addEventListener('keydown', handleKeyDown);
    
    // Focus first element
    setTimeout(() => {
      const firstFocusable = modal1.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    }, 50);
  };

  const closeModals = () => {
    overlay.classList.remove('is-active');
    modal1.classList.remove('is-active');
    modal2.classList.remove('is-active');
    document.body.classList.remove('occasion-modal-open');
    document.removeEventListener('keydown', handleKeyDown);
    // Wait for animation before removing inactivity class
    setTimeout(() => {
      modal1.classList.remove('is-inactive');
    }, 400);
  };

  closeBtns.forEach(btn => btn.addEventListener('click', closeModals));

  // Handle Card Selection
  occasionCards.forEach(card => {
    card.addEventListener('click', () => {
      // Remove selected from all
      occasionCards.forEach(c => c.classList.remove('is-selected'));
      // Add to clicked
      card.classList.add('is-selected');
      
      selectedOccasion = {
        name: card.dataset.name,
        tag: card.dataset.tag
      };

      // Update CTA
      ctaBtn.textContent = `See ${selectedOccasion.name} Products \u2192`; // ->
      ctaBtn.classList.add('is-active');
    });
  });

  // Handle CTA Click
  ctaBtn.addEventListener('click', () => {
    if (!selectedOccasion) return;

    // Transition to Modal 2
    modal1.classList.remove('is-active');
    modal1.classList.add('is-inactive');
    
    setTimeout(() => {
      modal2.classList.remove('is-inactive');
      modal2.classList.add('is-active');
      fetchAndRenderProducts(selectedOccasion);
    }, 300); // Wait for modal 1 to scale down
  });

  const fetchAndRenderProducts = async (occasion) => {
    const templateStr = window.theme?.locales?.recommended_occasion_styles || `Recommended {{ occasion }} Styles`;
    occasionTitle.textContent = templateStr.replace('{{ occasion }}', occasion.name);
    productsGrid.innerHTML = `
      <div class="occasion-loading">
        <div class="occasion-loading-spinner"></div>
        Fetching styles...
      </div>
    `;

    try {
      // Use Shopify Section Rendering API
      // Searching strictly by tag using the tag: prefix
      const response = await fetch(`/search?q=tag:${encodeURIComponent(occasion.tag)}&type=product&section_id=occasion-finder-results`);
      if (!response.ok) throw new Error('Network response was not ok');
      const htmlText = await response.text();
      
      // Parse the returned HTML (Shopify returns the HTML inside a div with the section ID)
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      
      // Extract the content from the rendered section
      const sectionContent = doc.querySelector('.shopify-section, [id^="shopify-section"]') || doc.body;
      
      productsGrid.innerHTML = sectionContent.innerHTML;
      
    } catch (error) {
      console.error('Error fetching occasion products:', error);
      productsGrid.innerHTML = `<p style="text-align:center; width:100%; color:red;">There was an error loading the styles. Please refresh the page.</p>`;
    }
  };

  // Initialize
  setupObserver();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initOccasionFinder);
} else {
  initOccasionFinder();
}
